/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_ProvisionInputs */

const cs_reports_provision = /** @type {(inputs: Reports_ProvisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Očekávaná provize`)
};

const en_reports_provision = /** @type {(inputs: Reports_ProvisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected commission`)
};

/**
* | output |
* | --- |
* | "Expected commission" |
*
* @param {Reports_ProvisionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_provision = /** @type {((inputs?: Reports_ProvisionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_ProvisionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_provision(inputs)
	return cs_reports_provision(inputs)
});